export default function Hero() {
  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-foreground-900">
      <div className="absolute inset-0">
        <img
          alt="BB COFFEE BeanhoodBrew coffee truck at Pusat Perniagaan Bukit Raja, Jalan Keluli AP7/AP, Seksyen 7, 40000 Shah Alam, Selangor (Infront of HARRAZ boutique)"
          className="w-full h-full object-cover object-center"
          src="https://storage.readdy-site.link/project_files/d4b7e9c4-1091-43d4-881a-3d7f0c6738ee/7deb1673-6162-4549-8987-dc579552a48a_compressed_COFFEE-TRUCK.webp"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50" />

      <div className="absolute inset-0 overflow-hidden pointer-events-none motion-reduce:hidden">
        {[...Array(6)].map((_, i) => (
          <div
            key={i}
            className={`absolute ${["top-[10%] left-[10%]", "top-[20%] left-[80%]", "top-[40%] left-[20%]", "top-[60%] left-[70%]", "top-[30%] left-[50%]", "top-[70%] left-[15%]"][i]} ${
              i % 3 === 0 ? "animate-float" : i % 3 === 1 ? "animate-float-slow" : "animate-float-reverse"
            } opacity-20`}
          >
            <div className={`w-10 h-10 flex items-center justify-center ${i === 2 ? "w-14 h-14" : i === 5 ? "w-16 h-16" : ""}`}>
              <i className={`ri-leaf-fill text-primary-300 ${i === 2 ? "text-5xl" : i === 5 ? "text-6xl" : i === 1 ? "text-3xl" : "text-4xl"}`} />
            </div>
          </div>
        ))}
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="animate-fade-in">
          <span className="inline-block px-4 py-1.5 mb-6 text-xs md:text-sm font-medium tracking-widest uppercase text-primary-300 bg-primary-500/10 rounded-full border border-primary-400/20">
            BeanhoodBrew
          </span>
        </div>
        <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-background-50 leading-tight mb-6 animate-fade-in-up animate-delay-200">
          Your Favourite<br />
          <span className="text-primary-400">Neighbourhood</span> Coffee Truck
        </h1>
        <p className="text-base md:text-lg text-background-200 mb-10 animate-fade-in-up animate-delay-400 max-w-xl mx-auto leading-relaxed">
          Freshness in Every Sip
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-up animate-delay-500">
          <a
            href="#menu"
            className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-full transition-all duration-300 hover:scale-105 active:scale-95 cursor-pointer inline-flex items-center justify-center gap-2"
          >
            View Menu
            <i className="ri-arrow-right-line" />
          </a>
          <a
            href="#find-us"
            className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 bg-background-50/15 hover:bg-background-50/25 text-background-50 font-semibold text-sm rounded-full border border-background-50/30 transition-all duration-300 hover:scale-105 active:scale-95 backdrop-blur-sm cursor-pointer inline-flex items-center justify-center gap-2"
          >
            Find Us
            <i className="ri-map-pin-line" />
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce-slow">
        <a href="#about" className="flex flex-col items-center gap-2 text-background-50/70 hover:text-primary-300 transition-colors duration-300 cursor-pointer">
          <span className="text-xs tracking-widest uppercase">Scroll</span>
          <i className="ri-arrow-down-line text-lg" />
        </a>
      </div>
    </section>
  );
}